import useCompute from "../Hooks/Compute";
export default function ComputeProvider({ children }) {
    useCompute();
    return children;
}